import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import { compactNullish } from 'essential-utils';
import * as React from 'react';
import { FlexBox } from '../../box';
import { TextField } from '../../textfield';
import { measureText } from '../../typography';
import { FacilityValue, facilityValueTypography } from './facility-value';
export const FacilityInput = (props) => {
    const { topNav, reduced, filled, emptySelectionLabel, value: _value, ...textfieldProps } = props;
    const [iconWidth, setIconWidth] = React.useState(0);
    const theme = useTheme();
    const { spacing } = theme;
    const displayValue = compactNullish(Array.isArray(_value) ? _value : [_value])
        .map((v) => v.name ?? v.facilityName)
        .join(', ') ||
        emptySelectionLabel ||
        '';
    // icon-width + padding + text-width
    const width = reduced
        ? iconWidth
        : `calc(${iconWidth}px + ${spacing(1)} + ${Math.min(facilityValueTypography.maxWidth, measureText(theme, displayValue, 'bodyDefault'))}px)`;
    const onIconRef = (icon) => {
        setIconWidth(icon?.getBoundingClientRect().width || 0);
    };
    return (_jsxs(FlexBox, { position: "relative", overflow: "hidden", children: [_jsx(TextField, { ...textfieldProps, slotProps: {
                    ...textfieldProps.slotProps,
                    htmlInput: {
                        ...textfieldProps.slotProps?.htmlInput,
                        style: { width, cursor: 'pointer' },
                        value: ''
                    }
                }, readOnly: true }), _jsx(FacilityValue, { topNav: topNav, reduced: reduced, filled: filled, sx: { position: 'absolute', left: 8 }, onIconRef: onIconRef, children: displayValue })] }));
};
